<template>
  <div :style="dividerStyles" />
</template>

<script>
export default {
  name: "HorizontalDivider",
  props: {
    dividerColor: {
      type: String,
      required: false,
      default: '#000033',
    },
    thickness: {
      type: String,
      required: false,
      default: '1',
    },
  },
  computed: {
    dividerStyles() {
      return { 'background-color': this.dividerColor, 'height': `${this.thickness}px` };
    },
  },
}
</script>
